module.exports = __webpack_public_path__ + "img/DW365-096.4a3c7f1d.jpg";